function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_6060_13988)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M19.9006 27.3395C15.3107 27.3395 11.6968 27.1559 7.1166 26.9047L5.83144 29.4267",
  stroke: "#FF7A00",
  className: "color-error-stroke",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M41.1589 29.4267L39.9027 26.9047C35.1293 27.1656 31.3221 27.3105 26.5486 27.3492",
  stroke: "#FF7A00",
  className: "color-error-stroke",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.2819 16.72H14.4507C13.765 16.7197 13.0929 16.9114 12.5105 17.2735C11.9282 17.6355 11.4588 18.1534 11.1557 18.7685L7.1166 26.9046",
  stroke: "#FF7A00",
  className: "color-error-stroke",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M39.9027 26.9046L35.8733 18.7685C35.5685 18.1527 35.0975 17.6344 34.5134 17.2724C33.9294 16.9104 33.2557 16.719 32.5686 16.72H29.1576",
  stroke: "#FF7A00",
  className: "color-error-stroke",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M39.1973 25.4842H40.5018L40.7724 24.3633C40.7986 24.2488 40.8471 24.1407 40.9153 24.0451C40.9835 23.9495 41.07 23.8683 41.1697 23.8063C41.2694 23.7444 41.3804 23.7027 41.4964 23.6839C41.6123 23.665 41.7307 23.6693 41.845 23.6965L45.1593 24.4792C45.2615 24.5033 45.3525 24.5613 45.4175 24.6438C45.4824 24.7263 45.5175 24.8284 45.5169 24.9334V25.7161C45.5169 26.0262 45.3937 26.3236 45.1744 26.5428C44.9551 26.7621 44.6577 26.8853 44.3477 26.8853H39.9027",
  stroke: "#FF7A00",
  className: "color-error-stroke",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.76401 25.4842H6.50784L6.22761 24.3633C6.20256 24.2492 6.15503 24.1412 6.08779 24.0457C6.02056 23.9502 5.93496 23.869 5.83601 23.807C5.73705 23.7449 5.62673 23.7032 5.51146 23.6842C5.3962 23.6652 5.27832 23.6694 5.1647 23.6966L1.84067 24.4986C1.73847 24.5226 1.64746 24.5807 1.58251 24.6631C1.51757 24.7456 1.48254 24.8477 1.48314 24.9527V25.7354C1.48314 26.0455 1.60633 26.3429 1.8256 26.5622C2.04486 26.7814 2.34226 26.9046 2.65235 26.9046H7.09727",
  stroke: "#FF7A00",
  className: "color-error-stroke",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M28.4715 26.9916C28.4949 26.1412 28.8444 25.3324 29.4476 24.7325C30.0508 24.1327 30.8616 23.7877 31.7121 23.7691C32.5626 23.7505 33.3877 24.0596 34.0166 24.6325C34.6455 25.2054 35.03 25.9981 35.0906 26.8467",
  stroke: "#FF7A00",
  className: "color-error-stroke",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M23.2246 28.7599C22.8342 28.7599 22.4596 28.9143 22.1826 29.1895C21.9056 29.4647 21.7487 29.8382 21.7462 30.2286V30.2286C21.7762 30.5989 21.9444 30.9442 22.2175 31.196C22.4905 31.4478 22.8483 31.5876 23.2198 31.5876C23.5912 31.5876 23.949 31.4478 24.2221 31.196C24.4951 30.9442 24.6634 30.5989 24.6934 30.2286V30.2286C24.6934 29.8391 24.5386 29.4655 24.2632 29.1901C23.9877 28.9146 23.6141 28.7599 23.2246 28.7599V28.7599Z",
  stroke: "#FF7A00",
  className: "color-error-stroke",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M23.3889 15.4831C22.539 15.4505 21.698 15.6661 20.9686 16.1037C20.2393 16.5413 19.6533 17.1819 19.2822 17.9472C19.1698 18.2613 19.1811 18.6063 19.3138 18.9124C19.4464 19.2185 19.6905 19.4627 19.9966 19.5954C20.3026 19.7282 20.6477 19.7395 20.9619 19.6273C21.276 19.515 21.5357 19.2874 21.6882 18.9908C21.8519 18.688 22.0971 18.4371 22.3959 18.2664C22.6947 18.0956 23.0353 18.0119 23.3792 18.0245C23.6067 18.01 23.8348 18.0422 24.0494 18.119C24.2639 18.1959 24.4605 18.3159 24.6271 18.4716C24.7936 18.6272 24.9265 18.8153 25.0177 19.0242C25.1089 19.2332 25.1563 19.4585 25.1572 19.6865C25.1572 20.6528 24.5291 21.0973 23.8237 21.6191C23.2183 21.9465 22.7165 22.4368 22.375 23.0344C22.0335 23.632 21.8659 24.3132 21.8911 25.0011V25.175C21.875 25.3681 21.8992 25.5625 21.9621 25.7458C22.025 25.9291 22.1252 26.0974 22.2564 26.24C22.3876 26.3826 22.547 26.4964 22.7245 26.5743C22.9019 26.6522 23.0936 26.6924 23.2874 26.6924C23.4812 26.6924 23.6729 26.6522 23.8504 26.5743C24.0278 26.4964 24.1872 26.3826 24.3184 26.24C24.4497 26.0974 24.5499 25.9291 24.6127 25.7458C24.6756 25.5625 24.6998 25.3681 24.6837 25.175V25.0011C24.6837 23.9865 25.3311 23.4937 26.0558 22.9332C26.6173 22.6011 27.0816 22.1272 27.4022 21.5591C27.7227 20.9909 27.8882 20.3485 27.8821 19.6961C27.8863 19.1177 27.7707 18.5446 27.5426 18.0129C27.3146 17.4813 26.979 17.0025 26.557 16.6069C26.135 16.2112 25.6357 15.9071 25.0904 15.7137C24.5452 15.5203 23.9659 15.4418 23.3889 15.4831V15.4831Z",
  stroke: "#FF7A00",
  className: "color-error-stroke",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));
var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_6060_13988"
}, /*#__PURE__*/React.createElement("rect", {
  width: 45,
  height: 17.2096,
  fill: "white",
  transform: "translate(1 15)"
})));
function SvgWindshieldNotFound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWindshieldNotFound);
export default __webpack_public_path__ + "static/media/windshield-not-found.979f96c8bcc962c88ee76adc63345ed7.svg";
export { ForwardRef as ReactComponent };